module.exports = __webpack_public_path__ + "prod/1.42.2/img/gaodun-icon.8fe0face.png";